import { withZod } from '@remix-validated-form/with-zod';
import { z } from 'zod';
import { zfd } from 'zod-form-data';

export const loginSchema = z.object({
	email: z.string().email('Please enter a valid email').max(254, 'Max length of 254'),
	password: z.string().max(50, 'Max length of 50'),
	remember: zfd.checkbox(),
});

export const loginValidator = withZod(loginSchema);

export type LoginForm = z.infer<typeof loginSchema>;
